<div class="crm-dashboard">
  <!-- Header Section -->
  <div class="crm-header">
    <div class="crm-title">
      <h2><i class="fas fa-chart-line"></i> Customer Relationship Management</h2>
      <p>Track and manage customer interactions and opportunities</p>
    </div>
    <div class="crm-actions">
      <button class="btn btn-primary" (click)="toggleEdit()">
        <i class="fas fa-edit"></i> {{ editingLeadStatus ? 'Cancel' : 'Edit Lead Info' }}
      </button>
    </div>
  </div>

  <!-- Lead Status Card -->
  <div class="crm-card lead-status-card">
    <div class="card-header">
      <h3><i class="fas fa-user-check"></i> Lead Status</h3>
      <div class="status-indicator" [style.background-color]="getLeadStatusColor(customerdata?.customer?.lead_status_id)"></div>
    </div>
    
    <div class="card-content" *ngIf="!editingLeadStatus">
      <div class="info-grid">
        <div class="info-item">
          <label>Current Status</label>
          <div class="status-badge" [style.background-color]="getLeadStatusColor(customerdata?.customer?.lead_status_id)">
            {{ getLeadStatusName(customerdata?.customer?.lead_status_id) || 'Not Set' }}
          </div>
        </div>
        
        <div class="info-item">
          <label>Lead Source</label>
          <div class="value">{{ getLeadSourceName(customerdata?.customer?.lead_source_id) || 'Not Set' }}</div>
        </div>
        
        <div class="info-item">
          <label>Lead Score</label>
          <div class="score-display">
            <div class="score-circle" [class]="getScoreClass(customerdata?.customer?.lead_score)">
              {{ customerdata?.customer?.lead_score || 0 }}
            </div>
            <span class="score-label">/ 100</span>
          </div>
        </div>
        
        <div class="info-item">
          <label>Next Follow-up</label>
          <div class="date-display">
            <i class="fas fa-calendar-alt"></i>
            {{ customerdata?.customer?.next_follow_up_date | date:'MMM dd, yyyy' || 'Not Scheduled' }}
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Form -->
    <div class="edit-form" *ngIf="editingLeadStatus">
      <div class="form-grid">
        <div class="form-group">
          <label for="leadStatus">Lead Status</label>
          <select id="leadStatus" [(ngModel)]="selectedLeadStatusId" class="form-select">
            <option value="">Select Status</option>
            <option *ngFor="let status of leadStatuses" [value]="status.id">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="leadSource">Lead Source</label>
          <select id="leadSource" [(ngModel)]="selectedLeadSourceId" class="form-select">
            <option value="">Select Source</option>
            <option *ngFor="let source of leadSources" [value]="source.id">
              {{ source.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="leadScore">Lead Score (0-100)</label>
          <div class="score-input-group">
            <input type="range" id="leadScore" [(ngModel)]="leadScore" min="0" max="100" class="score-slider">
            <div class="score-value">{{ leadScore || 0 }}</div>
          </div>
        </div>

        <div class="form-group">
          <label for="followUpDate">Next Follow-up Date</label>
          <input type="date" id="followUpDate" [(ngModel)]="nextFollowUpDate" class="form-input" (change)="updateFollowUp()">
        </div>
      </div>

      <div class="form-actions">
        <button class="btn btn-secondary" (click)="toggleEdit()">
          <i class="fas fa-times"></i> Cancel
        </button>
        <button class="btn btn-success" (click)="saveLeadStatus()">
          <i class="fas fa-save"></i> Save Changes
        </button>
      </div>
    </div>
  </div>

  <!-- Quick Actions -->
  <div class="quick-actions">
    <h3><i class="fas fa-bolt"></i> Quick Actions</h3>
    <div class="action-buttons">
      <button class="action-btn" (click)="scheduleFollowUp()">
        <i class="fas fa-calendar-plus"></i>
        <span>Schedule Follow-up</span>
      </button>
      <button class="action-btn" (click)="logActivity()">
        <i class="fas fa-plus-circle"></i>
        <span>Log Activity</span>
      </button>
      <button class="action-btn" (click)="createOpportunity()">
        <i class="fas fa-handshake"></i>
        <span>Create Opportunity</span>
      </button>
      <button class="action-btn" (click)="viewHistory()">
        <i class="fas fa-history"></i>
        <span>View History</span>
      </button>
    </div>
  </div>

  <!-- CRM Stats -->
  <div class="crm-stats">
    <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-chart-bar"></i>
      </div>
      <div class="stat-content">
        <h4>Lead Score</h4>
        <div class="stat-value">{{ customerdata?.customer?.lead_score || 0 }}</div>
        <div class="stat-label">Current Rating</div>
      </div>
    </div>
    
    <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stat-content">
        <h4>Days Since Contact</h4>
        <div class="stat-value">{{ getDaysSinceContact() }}</div>
        <div class="stat-label">Last Activity</div>
      </div>
    </div>
    
    <div class="stat-card">
      <div class="stat-icon">
        <i class="fas fa-trophy"></i>
      </div>
      <div class="stat-content">
        <h4>Conversion Rate</h4>
        <div class="stat-value">{{ getConversionRate() }}%</div>
        <div class="stat-label">Success Rate</div>
      </div>
    </div>
  </div>
</div>
